module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/geo_pic_pro.6fd8b3b8.png";